import { Fragment } from 'react';
import styled from 'styled-components';
import DeleteIcon from '@material-ui/icons/Delete';
import { Fab, TableBody, TableCell, TableRow } from '@material-ui/core';
import { Box } from 'reflexbox';

import { styles } from './Table';

const TableContent = ({
  rows,
  onClick,
  onMiddleClick,
  headers,
  isLiveDashboard,
  group = false,
  groupBy = '_id',
  groupTitle = '_id',
  renderGroupItem = null,
  groupActionField = '',
  groupActionIndex = 0,
  noHover = false,
}) => {
  const createHandleRowMouseDown = (route, id, skipId) => (e) => {
    switch (e.button) {
      case 1:
        e.preventDefault();
        onMiddleClick(route, id, skipId);
        break;
      default:
        break;
    }
  };

  let groupId = null;

  return (
    <TableBody>
      {headers && rows.map((row, i) => {
        let groupHeader = null;

        if (group && row[groupBy] && row[groupBy] !== groupId) {
          groupId = row[groupBy];

          groupHeader = (
            <TableRow>
              <GroupHeader colSpan={(headers?.length - groupActionIndex) || 1}>
                {renderGroupItem ? renderGroupItem(row) : (<GroupTitle>{row[groupTitle]}</GroupTitle>)}
              </GroupHeader>
              {groupActionField && row[groupActionField] && (
                <GroupAction colSpan={groupActionIndex}>{row[groupActionField]}</GroupAction>
              )}
            </TableRow>
          );
        }

        return (
          <Fragment key={i}>
            {groupHeader}
            <Row
              noHover={noHover}
              onMouseDown={createHandleRowMouseDown(
                row.route,
                row.ID,
                row.skipId,
              )}
              onClick={() =>
                isLiveDashboard
                  ? undefined
                  : onClick(row.route, row.ID, row.skipId, row)
              }
              $isLiveDashBoard={isLiveDashboard}
            >
              {headers &&
              headers.map(({ key }) => {
                return (
                  <TableCell style={styles.cell} key={key}>
                    {row[key]}
                  </TableCell>
                );
              })}
              {row.button && (
                <TableCell>
                  <FabButton
                    onClick={row.button.onClick}
                    color={row.button.title === 'Add' ? 'secondary' : 'primary'}
                  >
                    {row.button.icon || <DeleteIcon />}
                  </FabButton>
                </TableCell>
              )}
            </Row>
          </Fragment>
        );
      })}
    </TableBody>
  );
};
export default TableContent;

const Row = styled(TableRow)`
  &:hover {
    background-color: ${(props) => (props.noHover ? 'transparent' : '#f5f5f5')};
    cursor: ${(props) => (props.noHover ? 'initial' : 'pointer')};
  }
  && {
    height: ${(props) => (props.$isLiveDashBoard ? '100px' : '45px')};
  }
`;

const FabButton = styled(Fab)`
  && {
    transform: scale(0.6);
    margin-left: 0px;
  }
`;

export const GroupHeader = styled(TableCell)`
  background: #F9F9F9;
  border-bottom: 1px solid #E0E0E0;
  font-weight: 700 !important;
  font-size: 12px !important;
  padding: 3px 10px !important;
`;

export const GroupAction = styled(GroupHeader)`
  padding: 3px 0 !important;
`;

const GroupTitle = styled(Box)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
